export default __webpack_public_path__ + "static/PE-1-fdd381e1028131aa62e069dc216e5e21.png";